import * as React from 'react';
import { addClass } from '../../utils/css.js';
import '../../constants.js';
import './Row.scss.js';

const Row = ({ center, className, children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: addClass("vai-row", className, center ? `center-${center}` : void 0)
  }, children);
};

export { Row };
